import React from 'react'

import {
  Icon, PaymentAccepted, HelpFilled, MoreVertical, MenuItem,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

import Popover from './Popover'

function Wallet({ credits, accountName }) {
  return (
    <div className="card card--flat l-inner-compact wallet">
      <div className="wallet-content">
        <Icon
          svgComponent={PaymentAccepted}
          notSpaced
          color="dark"
        />

        <h5 className="cgt-legacy-heading-h5 cgt-mr-20">Your Business wallet balance</h5>

        <h5 className="cgt-legacy-heading-h5 cgt-legacy-color-brand-primary-100">${credits}</h5>

        <Tooltip
          id="balance-tooltip"
          tooltipClassName="u-text-center clickable"
          delayHide={1000}
          clickable
          content={(
            <>
              Your remaining&nbsp;
              <a href="https://help.cgtrader.com/hc/en-us/articles/13605659277841">
                Pre-paid credits
              </a> balance
            </>
          )}
        >
          <Icon
            svgComponent={HelpFilled}
            notSpaced
            color="primary"
            size="small"
          />
        </Tooltip>
      </div>

      <div className="wallet-content">
        <span className="cgt-legacy-color-typography-disabled">
          You are a part of the {accountName} business account
        </span>
        <Popover
          wrapperClass="wallet-popover"
          customClass="wallet-popover__content"
          content={(
            <MenuItem
              labelClassName="menu-item-label"
              href="https://help.cgtrader.com/hc/en-us/articles/13607017179409"
              label="What is business account?"
            />
          )}
        >
          <Icon
            svgComponent={MoreVertical}
            notSpaced
            color="dark"
          />
        </Popover>
      </div>
    </div>
  )
}

Wallet.propTypes = {
  credits: string.isRequired,
  accountName: string.isRequired,
}

export default Wallet
